import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom'

//CSS import
import './App.css';
import './css/aos.css';
import './css/animate.css';
import './css/flaticon.css';
import './css/icomoon.css';
import './css/ionicons.min.css';
import './css/owl.carousel.css';
import './css/owl.carousel.min.css';
import './css/owl.theme.default.min.css';
//Page import
import Home from './pages/Home'
import About from './pages/About'
import Resume from './pages/Resume'
import Projects from './pages/Projects'
import Contact from './pages/Contact';
import Footer from './pages/Footer';
//Component import
import Navbar from './components/Navbar/Navbar'



function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (

    <>
      <Navbar />
      <Switch>
        <Route exact path="/" component={Home} />
      </Switch>
      <About />
      <Resume />
      <Projects />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
